<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow (2).svg" style="width:20px" />&nbsp;Bodyweight Entry Lotwise
          </p>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="unionItem"
            :fields="fields"
            table-filter
            items-per-page-select
            :items-per-page="10"
            sorter
            pagination
            clickable-rows
            hover
            @row-clicked="rowClicked"
            caption="Breed"
          />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow (2).svg" style="width:20px" />&nbsp;Bodyweight Entry Lotwise Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput
              label="Id No"
              horizontal
              autocomplete="name"
              name="idNo"
              id="idNo"
              required
              v-model="idNo"
            />

            <CInput
              label="Age"
              horizontal
              autocomplete="age"
              name="age"
              id="age"
              required
              v-model="age"
            />
            <!-- <CInput
              label="Last weight Date"
              horizontal
              autocomplete="name"
              name="lastweightDate"
              id="lastweightDate"
              required
              v-model="lastweightDate"
            /> -->
             <CInput
                label="Weighting Date"
                type="date"
                horizontal
                   v-model="lastweightDate"
              />     
            <CInput
              label="Last weight"
              horizontal
              autocomplete="name"
              name="lastweight"
              id="lastweight"
              required
              v-model="lastweight"
            />
            <CInput
              label="Weight(kg)"
              horizontal
              autocomplete="name"
              name="weight"
              id="weight"
              required
              v-model="weight"
            />
            <CInput
              label="Weight Gain (gm/day)"
              horizontal
              autocomplete="name"
              name="weightGain"
              id="weightGain"
              required
              v-model="weightGain"
            />
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addChilling">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateChilling">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteChilling">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addChilling">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>
&nbsp;
          <CButton
            color="secondary"
            style="width:100px"
            v-if="cancelButton"
            @click="CancelChilling"
          >
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>&nbsp;
          <CButton color="info" v-if="addnewButton" @click="addnewChillingplus">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../tables/Table";
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper },

  data() {
    return {
      unionItem: [],
      editchilling: [],
      idNo: null,
      age: "",
      lastweightDate: "",
      lastweight: "",
      weight: "",
      weightGain: "",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      fields: [
        {
          key: "idNo",
          sortable: true
        },
        {
          key: "age",
          sortable: true
        },

        {
          key: "lastweightDate",
          sortable: true
        },
        {
          key: "lastweight",
          sortable: true
        },
        {
          key: "weight",
          sortable: true
        },
        {
          key: "weightGain",
          sortable: true
        }
      ]
    };
  },
  methods: {
    getbodyWeightLotList() {
      APIService.bodyWeightLotList().then(res => {
        if (res.status == 200) {
          this.unionItem = res.data;

           this.idNo =  this.unionItem[0].idNo;
      this.age = this.unionItem[0].age;
      this.lastweightDate =this.unionItem[0].lastweightDate;
      this.lastweight = this.unionItem[0].lastweight;
      this.weight = this.unionItem[0].weight;
      this.weightGain = this.unionItem[0].weightGain;
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editchilling = item;
      this.idNo = item.idNo;
      this.age = item.age;
      this.lastweightDate = item.lastweightDate;
      this.lastweight = item.lastweight;
      this.weight = item.weight;
      this.weightGain = item.weightGain;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
    },
    addChilling() {
      let idNo = this.idNo;
      let age = this.age;
      let lastweightDate = this.lastweightDate;
      let lastweight = this.lastweight;
      let weight = this.weight;
      let weightGain = this.weightGain;
      let data = {
        idNo,
        age,
        lastweightDate,
        lastweight,
        weight,
        weightGain
      };
      APIService.saveBodyWeightLot(data).then(res => {
        if (res.status == 200) {
          this.idNo = null;
          this.age = "";
          this.lastweightDate = "";
          (this.lastweight = ""),
            (this.weight = ""),
            (this.weightGain = ""),
            this.getbodyWeightLotList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    addnewChillingplus() {
      this.idNo = null;
      this.age = "";
      this.lastweightDate = "";
      (this.lastweight = ""),
        (this.weight = ""),
        (this.weightGain = ""),
        (this.addButton = false);
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getbodyWeightLotList();
    },

    CancelChilling() {
      this.idNo = null;
      this.age = "";
      this.lastweightDate = "";
      (this.lastweight = ""),
        (this.weight = ""),
        (this.weightGain = ""),
        (this.addButton = false);
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), 
      this.getbodyWeightLotList();
    },
    updateChilling() {
      let id = this.editchilling._id;
      let idNo = this.idNo;
      let age = this.age;
      let lastweightDate = this.lastweightDate;
      let lastweight = this.lastweight;
      let weight = this.weight;
      let weightGain = this.weightGain;

      let value = {
        idNo,
        age,
        lastweightDate,
        lastweight,
        weight,
        weightGain
      };
      let data = { id, value };
      APIService.bodyWeightLotUpdate(data).then(res => {
        if (res.status == 200) {
          this.idNo = null;
          this.age = "";
          this.lastweightDate = "";
          (this.lastweight = ""),
            (this.weight = ""),
            (this.weightGain = ""),
            (this.addButton = false);
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getbodyWeightLotList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },

    deleteChilling() {
      //     Swal.fire({
      //   title: 'Are you sure?',
      //   text: "You won't be able to revert this!",
      //   icon: 'warning',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes, delete it!'
      // }).then((result) => {
      //   if (result.value) {
      //     Swal.fire(
      //       'Deleted!',
      //       'Your file has been deleted.',
      //       'success'
      //     )
      //   }
      //   this.delete();
      // })

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    delete() {
      let id = this.editchilling._id;
      let data = { id };
      APIService.bodyWeightLotDelete(data).then(res => {
        if (res.status == 200) {
          this.idNo = null;
          this.age = "";
          this.lastweightDate = "";
          (this.lastweight = ""),
            (this.weight = ""),
            (this.weightGain = ""),
            (this.addButton = false);
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), 
       this.getbodyWeightLotList();
        }
      });
    }
  },
  created() {
    // this.getBreedList();
    this.getbodyWeightLotList();
  }
};
</script>
